// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"e61d3fa4","453":"fc245329","672":"588b95a0"}[chunkId] + ".chunk.js";
};